"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var single_1 = require("utils/selectors/single");
var EnableMarginsModal_1 = __importDefault(require("../Modals/EnableMargins/EnableMarginsModal"));
var DiscountSplitByException_1 = __importDefault(require("./DiscountSplitByException"));
var RechargeMargin = function (_a) {
    var _b;
    var item = _a.item;
    var _c = __read(react_1.default.useState(false), 2), openModal = _c[0], setOpenModal = _c[1];
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var handleClick = function (e) {
        e.stopPropagation();
        setOpenModal(!openModal);
    };
    if ((_b = rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.discountSplitMap) === null || _b === void 0 ? void 0 : _b.Xero) {
        return (0, jsx_runtime_1.jsx)(DiscountSplitByException_1.default, { item: item });
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ onClick: handleClick, size: "small", color: "green" }, { children: "Set Margins" })), (0, jsx_runtime_1.jsx)(EnableMarginsModal_1.default, { open: openModal, onClose: function () { return setOpenModal(!openModal); } })] }));
};
exports.default = RechargeMargin;
